<template>
  <el-table-column
    prop="source_user_name"
    sortable="custom"
    label="Átadó"
    show-overflow-tooltip
    min-width="150"
  />
</template>

<script>
  export default {
    propName: 'source_user_name',
  };
</script>
